module.exports = __webpack_public_path__ + "img/logoITD.455431d8.png";